
import TokenPreviewPage from './tokenpreviewpage'

export default TokenPreviewPage;